import { render, staticRenderFns } from "./Index.html?vue&type=template&id=ddfb4f00&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.scss?vue&type=style&index=0&id=ddfb4f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfb4f00",
  null
  
)

export default component.exports